import { useDeferredValue, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { ShopTypes } from '~/lib/data-contract';
import isDateInRange from '~/shared/components/DatePicker/DatePickerRange/helpers/isDateInRange';
import { DropdownItem } from '~/shared/components/MultipleSelector/models';

export function useFilterTableData(
    data: ShopTypes.CustomerInfoHeader[],
    dateRange: (Date | null)[],
) {
    const [query, setQuery] = useState<string>('');
    const [selectedStatus, setSelectedStatus] = useState<DropdownItem[]>([]);
    const [debouncedQuery] = useDebounce(query, 200);
    const deferredValue = useDeferredValue(debouncedQuery);

    const processedData = useMemo(() => {
        return data?.map((item) => {
            const itemString = [
                item?.invoiceDate
                    ? new Date(item.invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                item?.dueDate
                    ? new Date(item.dueDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                item?.invoiceNumber,
                item?.invoiceAmount,
                item?.remainingAmount,
                item?.customerOrderNumber,
                item.customerReference,
            ]
                .join(' ')
                .toLowerCase();

            return { ...item, itemString };
        });
    }, [data]);

    const filteredData = useMemo(() => {
        if (!processedData) return [];

        let filtered = processedData.filter(
            (item) =>
                (!item.invoiceDate || isDateInRange(item.invoiceDate, dateRange)) &&
                item.itemString.includes(deferredValue.toLocaleLowerCase()),
        );

        if (selectedStatus.length) {
            filtered = filtered.filter(
                (item) =>
                    item.filterValue &&
                    selectedStatus.some((status) => item.filterValue?.includes(status.value)),
            );
        }

        return filtered;
    }, [processedData, selectedStatus, deferredValue, dateRange]);

    return {
        query,
        filteredData,
        setQuery,
        setSelectedStatus,
        selectedStatus,
    };
}
